module.exports = __webpack_public_path__ + "media/video_202412.b54c95dd.mp4";